export enum ProfileEditModalResponseType {
  DELETE,
  SAVE,
  BACK,
}
